import { type SubmitEvent } from "react";

import { DefaultForm } from "../../../../../common/defaultForm/components/DefaultForm";
import { NetworkModal } from "../NetworkModal";
import { NetworkFormFields } from "./NetworkFormFields";
import { useNetworkForm } from "./useNetworkForm";

export const NetworkForm = () => {
  const {
    planSelected,
    stateSelected,
    citySelected,
    districtSelected,
    occupationAreaSelected,
    plans,
    states,
    cities,
    districts,
    occupationArea,
    isLoading,
    canSearch,
    services,
    open,
    setOpen,
    setPlanSelected,
    loadCities,
    loadDistricts,
    setDistrictSelected,
    setOccupationAreaSelected,
    searchNetwork,
  } = useNetworkForm();

  const handleSubmit = async (event: SubmitEvent<HTMLFormElement>) => {
    event.preventDefault();
    await searchNetwork();
  };

  return (
    <DefaultForm noPadding onSubmit={handleSubmit} testId="network_form">
      <NetworkModal
        open={open}
        services={services}
        onClose={() => setOpen(false)}
      />

      <NetworkFormFields
        plans={plans}
        states={states}
        cities={cities}
        districts={districts}
        occupationArea={occupationArea}
        planValue={planSelected}
        stateValue={stateSelected}
        cityValue={citySelected}
        districtValue={districtSelected}
        occupationAreaValue={occupationAreaSelected}
        isLoading={isLoading}
        canSearch={canSearch}
        onPlanChange={setPlanSelected}
        onStateChange={loadCities}
        onCityChange={loadDistricts}
        onDistrictChange={setDistrictSelected}
        onOccupationAreaChange={setOccupationAreaSelected}
      />
    </DefaultForm>
  );
};